// src/config/legal.js
// Single source of truth for the legal document version and canonical URLs.
// TERMS_VERSION MUST match the "Versión X.Y" shown in the header of the three
// legal docs (landing/{terms,privacy,ai-transparency}.html). Bumping it here
// (e.g. to '3.0') re-triggers the consent gate for every user on next login.
export const TERMS_VERSION = '2.0';

// Versión del texto del check «Acepto que PUX me contacte por WhatsApp» de /contratar
// (`contratar.contactWhatsAppConsent` en src/locales/{es,en,pt}/addons.json). Se guarda con
// cada decisión en `clientes/{uid}.contactoWhatsApp.version`, junto con el idioma en que se
// mostró. SI CAMBIA EL TEXTO EN CUALQUIER IDIOMA, SE SUBE ESTA VERSIÓN: es lo que permite
// saber qué aceptó exactamente cada persona.
export const CONTACTO_WHATSAPP_VERSION = '1.0';

export const LEGAL_URLS = {
  terms: 'https://pux.app/terms',
  privacy: 'https://pux.app/privacy',
  aiTransparency: 'https://pux.app/ai-transparency',
};
